import React from 'react';

function About() {
  return (
    <div>
      <div className="mt-2 mb-2 text-lg space-y-4 text-white">
        <p>
          En una vasta galaxia, donde los planetas están separados por miles de años luz y
          las civilizaciones conviven entre estrellas moribundas y nebulosas gigantes,
          existe una empresa que tiene una misión clara: procesar pagos intergalácticos.
          Su nombre es <span className="font-bold">Galactic Payments</span>, y aunque su
          lema es irónico y audaz, la realidad es que su trabajo no es nada fácil.
        </p>
        <p>
          Cada día en <span className="font-bold">Galactic Payments</span> es una aventura
          en sí misma. Las transacciones no solo cruzan distancias inimaginables, sino que
          también deben enfrentarse a desafíos que ninguna otra empresa de procesamiento de
          pagos terrestre siquiera soñaría.
        </p>
        <p>
          A pesar de todo, <span className="font-bold">Galactic Payments</span> sigue adelante.
          Cada pago, cada transacción, es un recordatorio de que, en esta galaxia desordenada y
          caótica, hacer negocios nunca fue fácil, y mucho menos instantáneo.
        </p>
        <p>
          Aunque <span className="font-bold">Galactic Payments</span> parece un caos intergaláctico
          con radiación, piratas espaciales y pagos desaparecidos, la compañía no deja nada al azar...
          o al menos, lo intenta. Cada equipo dentro de la organización tiene un rol vital en asegurar
          que los pagos lleguen a su destino, o al menos en evitar que se pierdan en un agujero negro.
          Cada equipo deberá colaborar en mantener en marcha esta ambiciosa empresa galáctica y
          sus objetivos clave para asegurar que <span className="font-bold">Galactic Payments</span> se
          mantenga como el líder del procesamiento de pagos intergalácticos.
        </p>
        <p>
          En el vasto cosmos <span className="font-bold">Galactic Payments</span> se enfrentará a desafíos
          titánicos, pero con la dedicación y el ingenio de sus equipos, están destinados a conquistar el
          universo, al menos ... financieramente.
          </p>
        <p>
          <div className="mt-8"></div>
          <span className="text-xs">
            Disclaimer:
            Los personajes y hechos retratados en este juego son completamente ficticios.
            Cualquier parecido a la realidad es pura coincidencia.
          </span>
        </p>
      </div>
    </div>
  );
}

export default About;
